import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "./reducers";
import sagas from "./sagas";

import { ReduxSagaEmitter } from "kuker-emitters";
const emitter = ReduxSagaEmitter();

const sagaMiddleware = createSagaMiddleware({
  sagaMonitor: emitter.sagaMonitor,
});

const middlewares = [sagaMiddleware];

export function configureStore(initialState) {
  // const loadState = () => {
  //   try {
  //     const serializedState = localStorage.getItem("state");
  //     if (serializedState === null) {
  //       return undefined;
  //     }
  //     return JSON.parse(serializedState);
  //   } catch (e) {
  //     return undefined;
  //   }
  // };

  // const saveState = state => {
  //   try {
  //     const serializedState = JSON.stringify(state);
  //     localStorage.setItem("state", serializedState);
  //   } catch (e) {
  //     // Ignore write errors;
  //   }
  // };

  // const persistedState = loadState();

  const store = createStore(
    //persistedState,
    reducers,
    initialState,
    compose(applyMiddleware(...middlewares))
  );

  //  store.subscribe(() => {
  //   saveState(store.getState());
  // });

  emitter.setStore(store);

  sagaMiddleware.run(sagas);

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const nextRootReducer = require("./reducers");
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
